import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import { useParams, useLocation } from "react-router-dom";
import ViewData from "./ViewData";
import PrepareDataTable from "./PrepareDataTable";
import { EnquiryListContainer } from "./EnquiryList.styled";
import AddEditEnquiry from "../AddEditEnquiry";
import "./EnquiryList.scss";
import NotFound from "@components/Errors/NotFound";
/**
 * Enquiry List,
 * Path - /Enquiries
 * @see See [Enquiry Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2978545672/Site+-+Enquiries)
 * @component
 */
const EnquiryList = (props) => {
  const { t, entityId, entityType, page, list, columnList, platformCountryId } =
    props;
  const params = useParams();

  const validPaths = ["all", "transport-quotation", "to-process"];
  const location = useLocation();
  const basePath = location.pathname.split("/").slice(0, 3).join("/") + "/";

  const [isRefreshList, setIsRefreshList] = useState(false);
  const [allColumnList, setAllColumnList] = useState(columnList);
  const [isAddEnquiryPopupVisible, setAddEnquiryPopupVisible] = useState(false);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  const createEnquiry = () => {
    setAddEnquiryPopupVisible(true);
  };
  const closeEnquiryCreationPopup = () => {
    setAddEnquiryPopupVisible(false);
  };

  useEffect(() => {
    if (params.path === "all") {
      setAllColumnList([
        "ID",
        "SITE_TYPE",
        "SITE_COMPANY",
        "PRODUCT",
        "OPERATION",
        "QUANTITY",
        "ENQUIRY_CREATION_DATE",
        "ENQUIRY_PRIORITY",
        "ENQUIRY_STEP",
      ]);
    }
    if (params.path === "to-process") {
      setAllColumnList([
        "ID",
        "SITE_TYPE",
        "SITE_COMPANY",
        "PRODUCT",
        "OPERATION",
        "QUANTITY",
        "ENQUIRY_CREATION_DATE",
        "ENQUIRY_PRIORITY",
        "ENQUIRY_DUE_DATE",
      ]);
    }
  }, [params.path]);

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  if (
    basePath === "/request/list/" &&
    !validPaths.includes(params.path) &&
    page === "list"
  ) {
    return <NotFound />;
  }

  return (
    <EnquiryListContainer className="enquiry-listing">
      {(page === "view" || page === "createSite") && (
        <ViewData
          isRefreshList={isRefreshList}
          updateRefeshStatus={updateRefeshStatus}
          entityId={entityId}
          entityType={entityType}
          createEnquiry={createEnquiry}
          page={page}
        />
      )}
      {page === "list" && (
        <PrepareDataTable
          isRefreshList={isRefreshList}
          updateRefeshStatus={updateRefeshStatus}
          columnList={allColumnList}
          type={params.path}
          entityId={entityId}
        />
      )}
      {isAddEnquiryPopupVisible && (
        <AddEditEnquiry
          title={t("ENQUIRY_NEW")}
          onClose={closeEnquiryCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
          isEditMode={false}
          siteId={entityId}
          platformCountryId={platformCountryId}
        />
      )}
    </EnquiryListContainer>
  );
};

EnquiryList.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
  list: PropTypes.string,
  columnList: PropTypes.arrayOf(PropTypes.string),
  platformCountryId: PropTypes.number,
};

EnquiryList.defaultProps = {
  page: "view",
  list: "all",
  columnList: [],
  platformCountryId: null,
};

export default withTranslation()(EnquiryList);
